var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-chart"},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":function($event){return _vm.onCanvasClick($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }